import DialogView from '../../dialog/Dialog.view.tsx';
import { useTranslation } from 'react-i18next';
import styles from './ChangeOwnPassword.mobile.module.css';
import InputView from '../../../components/input/Input.view.tsx';
import LoaderView from '../../../components/loader/Loader.view.tsx';
import type ChangeOwnPasswordProperties from '../ChangeOwnPassword.properties.ts';
import { useChangeOwnPasswordController } from '../ChangeOwnPassword.controller.ts';

export default function ChangeOwnPasswordMobileView(props: ChangeOwnPasswordProperties) {
  const { t } = useTranslation();
  const {
    loading,
    handleSave,
    enableSaveButton,
    currentPassword,
    setCurrentPassword,
    newPassword,
    setNewPassword,
    repeatPassword,
    setRepeatPassword,
  } = useChangeOwnPasswordController(props);

  return (
    <DialogView
      header={t('ui.changeOwnPasswordDialogHeader')}
      onBackdrop={props.handleDialogCloseClick}
    >
      <div>
        <>
          {loading && <LoaderView />}

          {!loading && (
            <>
              <div className={styles.form}>
                <div className={styles.field}>
                  <span className={styles.label}>{t('ui.currentPassword')}</span>
                  <InputView
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                    type="password"
                    width={220}
                  />
                </div>
                <div className={styles.field}>
                  <span className={styles.label}>{t('ui.newPassword')}</span>
                  <InputView
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    type="password"
                    width={220}
                  />
                </div>
                <div className={styles.field}>
                  <span className={styles.label}>{t('ui.repeatPassword')}</span>
                  <InputView
                    value={repeatPassword}
                    onChange={(e) => setRepeatPassword(e.target.value)}
                    type="password"
                    width={220}
                  />
                </div>
              </div>
              <div className={styles.hint}>{t('ui.passwordMinLength')}</div>
              <div className={styles.buttonContainer}>
                <button
                  className={styles.buttonSave}
                  onClick={handleSave}
                  disabled={!enableSaveButton()}
                >
                  {t('ui.save')}
                </button>
              </div>
            </>
          )}
        </>
      </div>
    </DialogView>
  );
}
